import { render } from "./ExamPlannerFeature.vue?vue&type=template&id=094377b3"
import script from "./ExamPlannerFeature.vue?vue&type=script&lang=js"
export * from "./ExamPlannerFeature.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__